import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 100+ AI PROMPTS FOR SUPERVISORS™',
  ideal: 'Team supervisors, shift leaders, operations coordinators, frontline managers, department supervisors, and professionals who want a more organized approach to daily management responsibilities.',
  was: '$54',
  now: '27',
  features: ['The complete 6-volume supervisory prompt system', '100+ ready-to-use AI prompts', 'Five professional bonuses', 'Instant compatibility with all major AI models', 'Instant digital access after purchase', '7-Day Risk-Free Guarantee', '♾️ Lifetime Access & Free Updates'],
  cta: 'Get 100+ AI Prompts for Supervisors™ now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit & debit cards'
}, {
  icon: SmartphoneIcon,
  label: 'Compatible devices'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-132" data-mp="4smd6n9zzxx7">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-133" data-mp="9ta4zb61wish">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-134" data-mp="eq0m81tldkfh">
          <p className="font-display text-xl font-black text-plum" data-id="element-135" data-mp="3d97d7eknjgo6">🔥 Limited Offer — Ending Soon!</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-136" data-mp="3i7iprx2c05a3">
            ⚠️ After this, the price returns to $54. This rate will not come back.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border-2 border-grape-soft bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(143,107,14,0.55)]" data-id="element-137" data-mp="3rxv8djql5odl">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] bg-plum px-6 py-3" data-id="element-138" data-mp="2reiaiftlojqn">
            <h3 className="font-display text-base font-black text-grape-soft" data-id="element-139" data-mp="2mhi5874krl0l">{plan.name}</h3>
          </div>
          <p className="text-sm text-plum/60" data-id="element-140" data-mp="318qxknzv3khf">
            <span className="font-semibold text-plum/80" data-id="element-141" data-mp="2w7bf93p2js2q">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-142" data-mp="28h7dl1vfy2ed">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-143" data-mp="28i8zy2hwqbbe">{plan.was} USD</span>
            <div className="flex w-full justify-center py-2" data-id="element-144" data-mp="23kqlxxp195wj">
              <span className="relative inline-block font-display leading-none" data-id="element-145" data-mp="2iggao3llrx4y">
                <span className="absolute right-full top-1/2 mr-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-146" data-mp="2dgk9ec4aijt3">
                  $
                </span>
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-147" data-mp="3ov7980n975vt">
                  {plan.now}
                </span>
                <span className="absolute left-full top-1/2 ml-2 -translate-y-1/2 text-sm font-bold text-plum/60" data-id="element-148" data-mp="59qic53nqizu">USD</span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-149" data-mp="3nhfxbw3zlmln">
              · One-time payment · Lifetime Access ·
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-150" data-mp="j0d837rfwyjs">
              · Payment will be processed in your local currency ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-151" data-mp="a8tcgui3n4t1">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-152" data-mp="ea56dc80ac71">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-153" data-mp="e82864wp9cr8" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-154" data-mp="16qpkovxmrjgp">
            <CTAButton size="md" data-id="element-155" data-mp="16sajixqz9okd">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-grape" data-id="element-156" data-mp="3f93bzokfozho">
            Save $27 (50% Off)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-157" data-mp="3aaie3vsnmrwe">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-158" data-mp="318smaouv1qy3">
                <Icon className="h-4 w-4 text-grape" data-id="element-159" data-mp="1t5e7hhdep9c" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape-soft/50 bg-white/80 p-5 text-left" data-id="element-160" data-mp="3szgng0wjawbr">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-161" data-mp="3k6li7772h0lz" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-162" data-mp="3k4iq8hmcsxem">
            <span className="font-display font-bold text-plum" data-id="element-163" data-mp="kjwwj8jc5pzv">🛡️ 7-Day Money-Back Guarantee.</span>{' '}
            If within the first 7 days you feel that this system doesn't save you at least 1 hour of paperwork per day, just ask for a refund. We will return 100% of your money, no questions asked. SIGMA SMART™ is committed to your career protection.
          </p>
        </div>
      </div>
    </section>;
}